import styled from 'styled-components';
import { spacing, heading5, fontWeights, Subtitle1 } from 'ui/theme';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusHalf};
  padding: ${spacing.plusHalf};
`;

export const PerformanceHeader = styled.h5`
  ${heading5};
  font-weight: ${fontWeights.semiBold};
  margin: 0;
`;

export const MessageTypesHeader = styled(Subtitle1)`
  margin: 0;
`;
